import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProgressionSelector } from '@/components/common/ProgressionSelector';
import { SearchInput } from '@/components/common/SearchInput';
import { TableGroupMenu } from '@/components/common/TableGroupMenu';
import { TableSortMenu } from '@/components/common/TableSortMenu';
import IndicatorHeader from '@/components/indicators/IndicatorHeader';
import { CollectImportDialog } from '@/components/indicators/collecte/CollectImportDialog';
import { CollecteExportDialog } from '@/components/indicators/collecte/CollecteExportDialog';
import CollecteFilterDrawer from '@/components/indicators/collecte/CollecteFilterDrawer';
import { CollecteRecalculationButton } from '@/components/indicators/collecte/CollecteRecalculationButton';
import CollecteTable from '@/components/indicators/collecte/CollecteTable';

const collecteSearchSchema = z.object({
  period: z.string().catch(''),
  entity_id: z.string().catch(''),
  page: z.number().catch(1),
  pageSize: z.number().catch(25),
  filter: z.string().catch(''),
  sort: z.string().catch(''),
  search: z.string().catch(''),
  group_by: z.string().catch(''),
});

export const Route = createFileRoute('/_layout/$slug/indicators/collecte/$year/')({
  component: RouteComponent,
  validateSearch: (search) => collecteSearchSchema.parse(search),
});

function RouteComponent() {
  const { year } = Route.useParams();
  const { period, entity_id, sort, search, group_by, filter } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <VStack maxW="100%" maxH="100vh" overflow={'hidden'} flexGrow={1}>
      <IndicatorHeader />
      <Box p="0rem 1rem" w="full" h="80%">
        <Box p="3px" bg="#F1F7FA" justifyContent="center" w="100%">
          <Flex bg="#F1F7FA" justifyContent="center">
            <HStack justifyContent="space-between" width="100%" p="1rem 1.5rem" bg="white" wrap="wrap">
              <SearchInput search={search} />
              <Flex wrap="wrap" gap={4} justifyContent={'space-between'} flexGrow={1}>
                <ProgressionSelector year={year} period={period} entity_id={entity_id} navigate={navigate} onlyEntity />
                <Flex gap={4}>
                  <CollecteFilterDrawer filter={filter} />
                  <TableSortMenu sort={sort} navigate={navigate} columnsDef={[]} />
                  <TableGroupMenu groupBy={group_by} navigate={navigate} columnsDef={[]} />
                  <CollecteRecalculationButton />
                  <CollectImportDialog default_entity_id={entity_id} />
                  <CollecteExportDialog />
                </Flex>
              </Flex>
            </HStack>
          </Flex>
          <CollecteTable />
        </Box>
      </Box>
    </VStack>
  );
}
